import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowMeterHeatmapComponent } from './flow-meter-heatmap.component';
import {MapLayersControlModule} from '../../../map/map-layers-control/map-layers-control.module';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {DxLoadPanelModule} from 'devextreme-angular';



@NgModule({
  declarations: [FlowMeterHeatmapComponent],
  imports: [
    CommonModule,
    MapLayersControlModule,
    LeafletModule,
    DxLoadPanelModule
  ],
  exports: [FlowMeterHeatmapComponent]
})
export class FlowMeterHeatmapModule { }
